import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=67273ac0&scoped=true&"
import script from "./Footer.controller.js?vue&type=script&lang=js&"
export * from "./Footer.controller.js?vue&type=script&lang=js&"
import style0 from "./Footer.styles.scss?vue&type=style&index=0&id=67273ac0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67273ac0",
  null
  
)

export default component.exports